/**
 * Rutas del onboarding (carrusel + registro + cuestionario de configuración de cuenta).
 * Fuente única: nadie hardcodea estos paths, así renombrar una pantalla es tocar un
 * solo lugar.
 *
 * La entrada es **`/auth`** y su contrato de URL no se toca — hay links externos
 * (landing, anuncios, mails) apuntando ahí que no controlamos:
 *   `/auth` login · `/auth?mode=signup` carrusel · `/auth?mode=reset` restablecer
 *   `/auth?next=…` destino post-login · `/auth?rubro=moda` carrusel del rubro.
 * Ver ADR-2026-07-31-onboarding-nuevo-es-el-flujo-real.
 *
 * (Este módulo nació con un prefijo de cuarentena `/onboarding-nuevo` mientras el
 * flujo no era el real; ya no hace falta: la rama es el aislamiento.)
 */

/** Entrada. `mode`/`rubro`/`next` son query params, no rutas. */
export const AUTH_PATH = '/auth';

/** `/auth?mode=signup` — el carrusel. Opcionalmente con el rubro de la campaña. */
export function authSignupPath(rubro?: string): string {
  return rubro ? `${AUTH_PATH}?mode=signup&rubro=${encodeURIComponent(rubro)}` : `${AUTH_PATH}?mode=signup`;
}

export const ONBOARDING_V2 = {
  /** Entrada (login por defecto). */
  auth: AUTH_PATH,
  /** Carrusel de bienvenida = `/auth?mode=signup`. */
  bienvenida: `${AUTH_PATH}?mode=signup`,
  /** Registro/login a pantalla completa (mobile). */
  registro: '/registro',
  /** Cuestionario post-registro: paso 1 y layout de los 4 pasos. */
  setup: '/configuracion-cuenta',
  setupCategoria: '/configuracion-cuenta/categoria',
  setupContenido: '/configuracion-cuenta/contenido',
  setupProducto: '/configuracion-cuenta/producto',
  setupGenerando: '/configuracion-cuenta/generando',
  setupResultados: '/configuracion-cuenta/resultados',
  /** Onboarding de marca (ADR-2026-09-28-onboarding-v2-etapa-1): el link es `setup`. */
  /** Las preguntas, entre el link y el tablero (ADR-2026-10-02-onboarding-v2-preguntas-con-cumbre). */
  setupPreguntas: '/configuracion-cuenta/preguntas',
  setupMarca: '/configuracion-cuenta/marca',
  /** Conectar el canal de venta, sólo si eligió una plataforma (ADR-2026-09-29-onboarding-v2-canal-de-venta). */
  setupCanal: '/configuracion-cuenta/canal',
  setupPiezas: '/configuracion-cuenta/piezas',
  setupListo: '/configuracion-cuenta/listo',
} as const;
